// ChannelHeader.jsx
import React, { useEffect, useState } from 'react';
import { Badge, Button, Col, Row, Form } from 'react-bootstrap';
import './Channel-header.css';   // estilos auxiliares (abajo)
import Admin_TOMis from './modals/Admin_TOMis';
import Modal_proyectos from '../../menus/Modal';
import Card_link from './modals/Card_link';
import Team_link from './modals/Team_link';
import CAS_certification from './modals/CAS_certification';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { add_user_permission_channel, certify_channel, insert_new_channel, load_channel, remove_permission_channel } from '../../../utils/crm_services';
import { loadCountriesData, buildCountrySelectOptions, buildCountryPhoneOptions } from '../../../utils/countries';
import Member_profile from './modals/Member_profile';


  

export default function ChannelHeader({
  channelName = 'Reseller Name',
  token,
  channel_id,
  usr_type,
  onSet,
  onCasAuthorizedChange,
  onChannelAdminChange,
}) {

    const isInternalUser = parseInt(usr_type, 10) === 0;
    const [canManageChannel, setCanManageChannel] = useState(isInternalUser);

    const [isModalOpen, setModalOpen] = useState(false);
    let [modal_content, setmodal_content] = useState("");
    const [modal_param_usr, setmodal_param_usr] = useState(0);
    const [modalContactMeta, setModalContactMeta] = useState({
        permission_id: 0,
        permission: 0,
        usr_type: null,
    });
    const [countryOptions, setcountryOptions] = useState([]);
    const [countryPhoneOptions, setCountryPoneOptions] = useState([]);
    const [description, setDescription] = useState('');
    const [isNameEdited, setIsNameEdited] = useState(false); // State to track if name is edited

   
    const [country, setCountry] = useState('');
    const [team, setTeammember] = useState([ ]);
    const [channelsTiers, setchannelsTiers] = useState([
        { label: 'Tier 1', value: 1 },
        { label: 'Tier 2', value: 2 },
        { label: 'Tier 3', value: 3 },
    ]);
    
    const [selectedTier, setSelectedTier] = useState(0);


    const [editableChannelName, setEditableChannelName] = useState(channelName);
    const [sourceStrategy, setsourceStrategy] = useState('');
    const [sourceStrategy_id, setsourceStrategy_id] = useState('');
    const [score, setscore] = useState(0);
    const [CasSince, setCASSince] = useState(null);
    
  
    const navigate = useNavigate();

    const setNewStrategy =(trello_id, title)=>{
        setsourceStrategy(title);
        setsourceStrategy_id(trello_id);
        setIsNameEdited(true);
        setModalOpen(false);
    }

    useEffect(() => {
            loadCountriesData()
              .then((data) => {
                setcountryOptions(buildCountrySelectOptions(data));
                setCountryPoneOptions(buildCountryPhoneOptions(data));
              })
              .catch((error) => console.error('Error fetching countries:', error));
          }, []);


    async function fetchloadChannel(thechannel_id) {
            const opportunityList = await load_channel(token,thechannel_id);
            if (opportunityList==="INVALID"){
                navigate("/");
            }else{
             
             

               setsourceStrategy(opportunityList["channel_data"][0].CARD_TITLE);
               setsourceStrategy_id(opportunityList["channel_data"][0].source_strategy);
               setDescription(opportunityList["channel_data"][0].description);
               setEditableChannelName(opportunityList["channel_data"][0].name);
               onSet(opportunityList["channel_data"][0].name);
               setCountry(opportunityList["channel_data"][0].country);
               setscore(opportunityList["channel_data"][0].count_tomis);
               const casSinceVal = opportunityList["channel_data"][0].CAS_since;
               setCASSince(casSinceVal);
               const isCasAuthorized =
                 Boolean(casSinceVal && casSinceVal !== '0000-00-00');
               onCasAuthorizedChange?.(isCasAuthorized, thechannel_id);
               const manageChannel =
                 isInternalUser || Boolean(opportunityList.can_manage_channel);
               setCanManageChannel(manageChannel);
               onChannelAdminChange?.(manageChannel);
               setSelectedTier(parseInt(opportunityList["channel_data"][0].tier));
               const tempTeam = opportunityList["permission_data"].map((celement, index) => {
                return {
                  permission_id: celement.permission_id,
                  usr_name: celement.usr_name==="" ? celement.email_id : celement.usr_name,
                  usr_id: celement.usr_id,
                  usr_type: celement.type,
                  email: celement.email_id,
                  permission: celement.permission ?? 0,
                  index:index
                };
              });
    
               setTeammember( [{permission_id:0, 
                                    usr_id:opportunityList["channel_data"][0].created_by,
                                    usr_name:opportunityList["channel_data"][0].owner_name,
                                    email:opportunityList["channel_data"][0].email_id,
                                    usr_type:4
               },...tempTeam]); //usr_type: es el creador y owner
               
              //usr_type:
              //4 - Owner de esta oportunidad
              //0 - Usuario de TOMi
              //1 - Usuario del Mayorista
              //2 - Usuario del canal
                
            }
            }

    useEffect(() => {
        if (channel_id !== null) {
              setCanManageChannel(isInternalUser);
              fetchloadChannel(channel_id);
              setIsNameEdited(false);
        }
    }, [channel_id, isInternalUser]); 

        

    const getOptionByValue = (value) => {
      return countryOptions.find(option => option.value === value);
    };

    const getTierByValue = (value) => {
      return channelsTiers.find(option => option.value === value);
    };

    const formatOptionLabel = ({ label, flagUrl }) => (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {flagUrl && <img src={flagUrl} alt={`Flag of ${label}`} style={{ width: '20px', marginRight: '10px' }} />}
        <span>{label}</span>
      </div>
    );
    
    const handleNameChange = (event) => {
      const newValue = event.target.value;
      setEditableChannelName(newValue);
      if (!isNameEdited)
          setIsNameEdited(true);
  };

     async function removePermission(permission_id) {
  
          const addUserPerm = await remove_permission_channel(token,permission_id);
          if (addUserPerm==="INVALID"){
            navigate("/");
          }else{
            fetchloadChannel(channel_id);
         }
      }
      
      
  const setNewMember =(id)=>{
      setModalOpen(false);
      addUserPermission(id);
  }

   

  
  async function addUserPermission(email_id) {
      const addUserPerm = await add_user_permission_channel(token,channel_id, email_id);
      if (addUserPerm==="INVALID"){
        navigate("/");
      }else{
        fetchloadChannel(channel_id);
    }
  }

   const createNewChannel =() =>{
          
            async function fetchcreateNew(name, thechannel_id) {
  
              const channelList = await insert_new_channel(token,name, description, country,  thechannel_id, sourceStrategy_id, selectedTier );
              if (channelList==="INVALID"){
                navigate("/");
              }else if (channelList==="UPDATED"){
                fetchloadChannel(thechannel_id);
                setIsNameEdited(false);
              }else{
                navigate("/channel_panel?id=" + channelList);
             }
            }
  
            fetchcreateNew(editableChannelName, channel_id);
     
      }


          
    async function certifyCurrentChannel(file, ch_id) {
        const channelList = await certify_channel(token,  channel_id, file);
        if (channelList==="INVALID"){
            navigate("/");
        }else if (channelList==="UPDATED"){
            setModalOpen(false);
            fetchloadChannel(channel_id);
        }
    }
  
          
     
  

  return (
    
    
     
    <header className="channel-header w-100 pb-1 mb-2">
        <Modal_proyectos isOpen={isModalOpen} onClose={() => setModalOpen(false)}
               title={
                modal_content === 'Card_link' ? 'Source Strategy' :
                modal_content === 'Team_link' ? 'Add member' :
                modal_content === 'Admin_TOMis' ? 'Link TOMi' :
                modal_content === 'Member_profile' ? 'Member Profile' :
                modal_content === 'CAS_certification' ? 'Certify as CAS' :
                ''
            } >
            {modal_content === 'Admin_TOMis'  &&  <Admin_TOMis token={token} channel_id={channel_id} canEdit={canManageChannel}></Admin_TOMis>}
            {modal_content === 'Member_profile'  &&  <Member_profile
                token={token}
                modal_param_usr_email={modal_param_usr}
                countryOptionsMnu={countryOptions}
                countryPhoneOptionsMnu={countryPhoneOptions}
                channel_id={channel_id}
                canEdit={canManageChannel}
                contactPermissionId={modalContactMeta.permission_id}
                contactChannelPermission={modalContactMeta.permission}
                onChannelPermissionChange={() => fetchloadChannel(channel_id)}
                onClose={() => setModalOpen(false)}
            ></Member_profile>}
            {modal_content === 'Card_link'  &&  <Card_link  token_num={token}   onSet={(id, title) => setNewStrategy(id, title)}></Card_link>}
            {modal_content === 'Team_link'  &&  <Team_link  onSet={(id) => setNewMember(id)}  onClose={(e) => {
                
                setModalOpen(false);

                }}  ></Team_link>}
            {modal_content === 'CAS_certification'  &&  <CAS_certification  certifyAction={(attachedFile) => certifyCurrentChannel(attachedFile, channel_id)}  onClose={() => setModalOpen(false)}  ></CAS_certification>}
        </Modal_proyectos>

        
      <div className="row align-items-start gy-2 g-2">
      <Col xs={12} md={7} className="channel-header-main-col">
        {/* Columna izquierda ------------------------------------------------- */}
        <Row className="align-items-start"> {/* Usamos Row para la distribución principal */}
            {/* Columna para Channel Name */}
            <Col xs={12} md={7}>
                <div className="label-normal">
                    Reseller Name:
                </div>
                <textarea
                    rows={2}
                    className="display-5 fw-bold mb-0 text-start opportunity-name-input form-control"
                    value={editableChannelName}
                    onChange={handleNameChange}
                    readOnly={!canManageChannel}
                ></textarea>
            </Col>

            {/* Columna para Country Select y Link Strategy */}
         
            <Col xs={12} md={5} className="d-flex flex-column justify-content-start"> {/* Usamos d-flex y flex-column */}
                <div className="mb-3"> {/* Margen inferior para separar el Select del botón */}
                   {/* Contenedor para el Badge/Botón Link Strategy */}
                   {isInternalUser && (
                    <div  style={{ cursor: "pointer" }}  className="d-flex align-items-center mb-3">
                        <div>
                            {sourceStrategy ? (
                                <Badge pill bg="primary" className="chip d-inline-flex align-items-center gap-2 px-3 py-2 fs-8"
                                onClick={() => {
                                    setmodal_content("Card_link");
                                    setModalOpen(true);
                                }}>
                                  
                                    {sourceStrategy && sourceStrategy.length > 25
                                        ? sourceStrategy.slice(0, 25) + '...'
                                        : sourceStrategy}

                                 <button
                                     aria-label={`Remove`}
                                     className="btn-close btn-close-white btn-close-sm ms-1"
                                     onClick={(event) =>{ 
                                        event.stopPropagation();
                                        setNewStrategy(0, '')
                                         }
                                     }
                                 />
                                </Badge>
                            ) : (
                                <Button variant="outline-primary" size="sm" onClick={() => {
                                    setmodal_content("Card_link");
                                    setModalOpen(true);
                                }}> 
                                    Link Strategy
                                </Button>
                            )}
                        </div>
                        
                    </div>
                )}
                    <div className="d-flex flex-row flex-wrap gap-2 align-items-end channel-header-country-tier">
                        <div className="flex-grow-1 text-muted lh-sm channel-header-country-select" style={{ minWidth: 0 }}>
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                options={countryOptions}
                                isLoading={countryOptions.length === 0}
                                formatOptionLabel={formatOptionLabel}
                                onChange={(selectedOption) => {
                                    setIsNameEdited(true);
                                    setCountry(selectedOption.value);
                                }}
                                value={getOptionByValue(country)}
                                placeholder="Country..."
                                isSearchable
                                isDisabled={!canManageChannel}
                                styles={{
                                    container: (provided) => ({
                                        ...provided,
                                        minWidth: 0,
                                        flex: 1,
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9999
                                    }),
                                    menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999
                                    })
                                }}
                            />
                        </div>
                        {isInternalUser && (
                            <div className="text-muted lh-sm channel-header-tier-select">
                                <Select
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    options={channelsTiers}
                                    isLoading={countryOptions.length === 0}
                                    formatOptionLabel={formatOptionLabel}
                                    onChange={(selectedOption) => {
                                        setIsNameEdited(true);
                                        setSelectedTier(selectedOption.value);
                                    }}
                                    value={getTierByValue(selectedTier)}
                                    placeholder="Tier..."
                                    isSearchable
                                    styles={{
                                        container: (provided) => ({
                                            ...provided,
                                            minWidth: 0,
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            zIndex: 9999
                                        }),
                                        menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999
                                        })
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>

               
            </Col>

           
        </Row>

        <Row className="align-items-start">
              <Form.Control
                  as="textarea"
                  rows={2}
                  value={description}
                  placeholder="Description..."
                  readOnly={!canManageChannel}
                  onChange={(e) => {
                      setIsNameEdited (true);
                      setDescription(e.target.value)
                  }}
                  />
        </Row>

         <div
                    className={`d-flex flex-wrap gap-2 justify-content-lg-end ${isNameEdited ? 'mt-1 mb-0' : 'mb-0'}`}
                >
                    {/* Conditionally render the Save Change button */}
                    {canManageChannel && isNameEdited && (
                    <Button
                        variant="danger"
                        size="sm"
                        onClick={()=>{createNewChannel()}}
                        // Call the new save handler
                    >
                        Save Change
                    </Button>
                    )}
                    {/* You might also want a Cancel button here if the name is edited */}
                   
                </div>
      </Col>
      
     <Col xs={12} md={3} className="channel-header-contacts-col">
    <div className="d-flex flex-column h-100">
        <div>
            <div className="d-flex align-items-center mb-2">
                <h5 className="me-2 mb-0 fw-normal">Contacts:</h5>
                {canManageChannel && (
                <Button
                    variant="outline-dark"
                    size="sm"
                    className="square-btn"
                    onClick={() => {
                        setmodal_content("Team_link");
                        setModalOpen(true);
                    }}
                >
                    +
                </Button>
                )}
            </div>

            <div className="d-flex flex-wrap gap-2">
                {team.map((m) => {
                    const contactFullName =
                        m.usr_name != null && m.usr_name !== ''
                            ? String(m.usr_name)
                            : '';
                    const contactBadgeLabel =
                        contactFullName.length > 8
                            ? `${contactFullName.slice(0, 8)}...`
                            : contactFullName;
                    return (
                    <Badge
                        key={m.permission_id}
                        title={contactFullName || undefined}
                        bg={m.usr_type == 4 ? 'warning' : m.usr_type == 0 ? 'info' : m.usr_type == 1 ? 'secondary' : 'danger'}
                        pill
                        style={{ cursor: 'pointer' }} 
                        className="chip d-inline-flex align-items-center gap-2 px-3 py-2 fs-8"
                          onClick={() => {
                            setmodal_param_usr (m.email);
                            setModalContactMeta({
                                permission_id: m.permission_id,
                                permission: m.permission ?? 0,
                                usr_type: m.usr_type,
                            });
                            setmodal_content("Member_profile");
                            setModalOpen(true);
                    }}
                    >

                        {contactBadgeLabel}
                        {canManageChannel && m.usr_type != 4 && (
                            <button
                                aria-label={`Remove ${m.usr_name}`}
                                className="btn-close btn-close-white btn-close-sm ms-1"
                                    onClick={(e) => { // 👈 Recibe el objeto del evento
                                        e.stopPropagation(); // 👈 ¡Detiene la propagación!
                                        removePermission(m.permission_id);
                                    }}
                            />
                        )}
                    </Badge>
                    );
                })}
            </div>
        </div>

        {/* --- Cambios aquí --- */}
        <div className="mt-auto pt-3"> {/* mt-auto empuja al final, pt-3 añade espacio arriba */}
            {(!CasSince || CasSince === "0000-00-00")  ? (
                canManageChannel ? (
                <Button
                    variant="danger"
                    size="sm"
                    className="w-100"
                    onClick={() => {
                        setmodal_content("CAS_certification");
                        setModalOpen(true);
                    }}
                >
                    Certify as CAS
                </Button>
                ) : null
            ) : (
                <div className="d-grid"> {/* d-grid para que el badge ocupe el ancho del botón */}
                    <Badge bg="success" className="p-2"> {/* p-2 para más padding si es necesario */}
                        CAS since {new Date(CasSince).toLocaleDateString()} 
                    </Badge>
                </div>
            )}
        </div>
    </div>
</Col>
      <Col xs={12} md={2} className="channel-header-score-col">
          <div
            className="channel-header-tomi-score text-md-end"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setmodal_content('Admin_TOMis');
              setModalOpen(true);
            }}
          >
            <h3 className="fw-normal text-muted mb-1 channel-header-tomi-title">TOMi8 DEMOS</h3>
            <div className="channel-header-tomi-count fw-semibold">{score}</div>
           
          </div>
         
      </Col>
     
      </div>
    </header>
  );
}
